export default __webpack_public_path__ + "static/media/sharepoint3.4d139e92.png";